import React from "react";
import Typography from "@material-ui/core/Typography";

export const CorePrinciples = ({ refProp }) => {
  return (
    <div ref={refProp}>
      <Typography variant="h3" component="h2">
        <u>Core Principles</u>
      </Typography>
      <p>
        1) CA is open to anyone and everyone, and is considered an equal
        opportunities community, free from discrimination or preferential
        treatment.
      </p>
      <p>
        2) Although CA focuses on hosting Milsim games, anyone is free to play
        any game through CA.
      </p>
      <p>3) Membership of CA shall be restricted to those aged 18+.</p>
    </div>
  );
};

export default CorePrinciples;
